<template>
  <DBox :id="'cmp-catalog-products-stock_location'" :addButton="false">
    <Dropdown2
      :label="$t('stock_location')"
      :placeholder="$t('choose') + ' ' + $t('stock_location')"
      :disabled="selectedProductDetails.disabled"
      deselect
      :options="selectedProductDetails.all_stock_locationsTV"
      :selected="
        selectedProductDetails.all_stock_locationsTV.find(
          (c) => c.value == selectedProductDetails.product.stock_location_id
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('stock_location_id', e)"
    />

    <div
      class="fc2 valued disabled fc2-textfield"
      style="
        height: 32px;
        --fc2-lw: 115px;
        --fc2-cw: auto;
        --fc2-height: 32px;
        --bb: 0px;
      "
      :placeholder="$t('stock_qty')"
      value="0"
      type="text"
      validators=""
      cv=""
      autocomplete="off"
    >
      <label :title="$t('stock_qty')" for="stock_qty_at" class="fc2-label txtov">
        <span> {{ $t("stock_quantity") }} </span>
      </label>
      <div class="fc-control">
        <span
          class="ut-link ut-text-accent5"
          style="margin-right: 5px"
          @click="onAccountClick"
          >{{ getAccountName() }}</span
        >{{ selectedProductDetails.stock_qty_on_stock_location || 0 }}
      </div>
    </div>

    <!-- <TextField2
      :disabled="true"
      :id="'stock_qty_at'"
      :placeholder="$t('stock_qty_at')"
      :label="$t('stock_qty_at')"
      :value="selectedProductDetails.stock_qty_on_stock_location"
      @blur="onTextFieldValueChange"
      bb="0px"
    /> -->
  </DBox>
</template>

<script>
import { distributionAccountListLDTRoutes } from "../../../distribution/router/routes";
export default {
  props: {
    selectedProductDetails: {
      required: true,
    },
  },
  computed: {
    account_id: function () {
      return this.selectedProductDetails?.stock_location?.account_id;
    },
  },
  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },
    getAccountName: function () {
      if (
        this.selectedProductDetails?.stock_location?.account_id &&
        this.selectedProductDetails?.stock_location?.account_name
      ) {
        return this.selectedProductDetails?.stock_location?.account_name;
      }
      return "";
    },
    onAccountClick: function () {
      this.$router.push({
        name: distributionAccountListLDTRoutes.names.tab,
        params: {
          account_id: this.account_id,
          tab: "overview",
        },
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-stock_location {
  .fc2 {
    .fc-control {
      background-color: white;
      &:hover {
        background-color: var(--fc2-bc);
      }
    }
  }
}
</style>
